<div class="card p2p-chart" style="min-width: 800px; min-height: 450px;">
    <div class="row">
        <div class="col-12"><h5>User Graphs</h5></div>
        <div class="col-12 text-center"><span class="p-buttonset">
            <button type="button" class="btn" (click)="updateDays(90)">Peer Audit History</button>
            <button type="button" class="btn" (click)="getPatientData()">Shift Patient Counts</button>
            <button type="button" class="btn" (click)="getFlagsData()">Shift Audit Totals</button>
        </span></div>
        <div class="col-12"></div>
    </div>
    <p-chart [type]="chartType" [data]="data" [options]="chartOptions"></p-chart>
</div>
